
import React, {useState} from 'react';
import { Spacing } from '_styles';
import loadingDots from '_assets/images/PRM-Logo-PNG/loading-dots.json';
import Lottie from "react-lottie";
import { CustomSpinner } from '_atoms';
import Row from 'react-bootstrap/Row';

const Container = (props) => {
    return (
        <div 
            className={props.className}
            style={{
                flex: 1, 
                marginRight:Spacing.SCALE_8, 
                marginLeft:Spacing.SCALE_8,
                opacity: props.loading ? 0.4 : 1.0
            }} >
            <div {...props}>{props.children}</div>
            {
                props.loading ?
                    <Row style={{position:'absolute', top:'50%'}}>
                        <CustomSpinner />
                    </Row>
                :
                    null
            }
        </div>
    );
};

const fieldData = (props) => {

    const loadingDotsOptions = {
        loop: true,
        autoplay: true,
        animationData: loadingDots,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice",
        }
    }

    const renderOptions = (status) => {
        switch(status) {
            case 'idle':
                return (
                    <Lottie options={loadingDotsOptions} height={40} width={40} />
                );
            case 'loading':
                return (
                    <Lottie options={loadingDotsOptions} height={40} width={40} />
                )
            case 'succeeded':
                return props.children;
            case 'failed':
                return (
                    <p style={{color:Colors.TEXT_COLOR}}>failed</p>
                )
            default:
                return props.children;
        }
    }

    return (
        <>
            <div style={{ }}>
                { renderOptions(props.dataStatus) }
            </div>
        </>
    );

}

const Data = (props) => {

    const tripsRenderOptions = (status) => {
            switch(status) {
            case 'idle':
                return (
                    <p style={{color:Colors.TEXT_COLOR}}>idle</p>
                );
            case 'loading':
                return (
                    <p style={{color:Colors.TEXT_COLOR}}>loading...</p>
                );
            case 'succeeded':
                return props.children;
            case 'failed':
                return (
                    <div>
                        <p style={{color:Colors.TEXT_COLOR}}> Error </p>
                    </div>
                );
            default:
                return (<>{props.children}</>);
            };
        };

        return (
            <>
                <div style={{width:props.width, height:props.height}}>
                    { tripsRenderOptions(props.dataStatus) }
                </div>
            </>
        );
}

Container.Data = Data;
Container.fieldData = fieldData;
export default Container;
